import { Box, Flex, Skeleton, useColorModeValue } from '@chakra-ui/react';

interface SkeletonTableProps {
	rows?: number;
	columns?: number;
}

export default function SkeletonTable({ rows = 5, columns = 4 }: SkeletonTableProps) {
	const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');

	return (
		<Box w='100%' overflow='hidden'>
			{/* Header */}
			<Flex
				py='12px'
				px='16px'
				borderBottom='1px solid'
				borderColor={borderColor}
				gap='16px'
			>
				{Array.from({ length: columns }).map((_, i) => (
					<Skeleton
						key={`header-${i}`}
						height='12px'
						borderRadius='6px'
						flex={i === 0 ? 2 : 1}
					/>
				))}
			</Flex>
			{/* Rows */}
			{Array.from({ length: rows }).map((_, rowIdx) => (
				<Flex
					key={`row-${rowIdx}`}
					py='14px'
					px='16px'
					borderBottom='1px solid'
					borderColor={borderColor}
					gap='16px'
					align='center'
				>
					{Array.from({ length: columns }).map((_, colIdx) => (
						<Skeleton
							key={`cell-${rowIdx}-${colIdx}`}
							height='14px'
							borderRadius='6px'
							flex={colIdx === 0 ? 2 : 1}
						/>
					))}
				</Flex>
			))}
		</Box>
	);
}
